import { render, staticRenderFns } from "./ModifierModal.vue?vue&type=template&id=f277fc9a&scoped=true&"
import script from "./ModifierModal.vue?vue&type=script&lang=js&"
export * from "./ModifierModal.vue?vue&type=script&lang=js&"
import style0 from "./ModifierModal.vue?vue&type=style&index=0&id=f277fc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f277fc9a",
  null
  
)

export default component.exports